import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable()
export class SharedService {

  constructor(
    private http: HttpClient
  ) { }
  // for company
  getStats(): Observable<any> {
    return this.http.get(
      `/stats`,
      {}
    );
  };
  getUserStats(): Observable<any> {
    return this.http.get(
      `/user/stats`,
      {}
    );
  };
  // for user
  getJobList(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/job`,
      {params: params}
    );
  };
  // for user
  searchJob(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/search/job`,
      {params: params}
    );
  };
  // for user
  getFeaturedList(): Observable<any> {
    return this.http.get(
      `/feature/job`,
      {}
    );
  };
  // for user
  getDetail(slug): Observable<any> {
    return this.http.get(
      `/job/${slug}`,
      {}
    );
  };
  // for user
  apply(job): Observable<any> {
    return this.http.patch(
      `/job/apply`,
      job,
      {} // {jobId : ''} or {jobId: '', undo: 1}
    );
  };
  // for user
  applicationHistory(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/application/history/job`,
      {params: params}
    );
  };
  // only admin
  getAll(): Observable<any> {
    return this.http.get(
      `/get/all/job`,
      {}
    );
  };
  // only admin /feature/job
  feature(job): Observable<any> {
    return this.http.patch(
      `/feature/job`,
      job,
      {} // {jobId: '', feature: 0/1}
    );
  };
  // only admin
  getCompanyJobs(id): Observable<any> {
    return this.http.get(
      `/company/jobs/${id}`,
      {}
    );
  };
  searchCompany(params?: HttpParams): Observable<any> {
    return this.http.get(
      `/company/search`,
      {params: params}
    );
  };
  editProfile(profile): Observable<any> {
    return this.http.patch(
      `/user/profile`,
      profile,
      {}
    );
  }
  inviteUser(data): Observable<any> {
    return this.http.post(
      `/invite/user`,
      data,
      {}
    );
  }
}
